import { STATUS } from "@/constants/statuses";
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { singleton } from "tsyringe";

import InstagramPostEntity from "../entities/InstagramPostEntity";

export interface InstagramPostsState
    extends EntityState<InstagramPostEntity, number>,
        ActiveState {
    paginationMeta: {
        perPage: number;
        totalCount: number;
        currentOffset: number;
        page: number;
    };
    status: STATUS;
}

export function createInitialState(): InstagramPostsState {
    return {
        paginationMeta: {
            perPage: 0,
            totalCount: 0,
            currentOffset: 0,
            page: 0,
        },
        active: null,
        status: STATUS.VIRGIN,
    };
}
@singleton()
@StoreConfig({ name: "instagram-posts", idKey: "id" })
class InstagramPostsStore extends EntityStore<InstagramPostsState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status: status,
        }));
    }
}

export default InstagramPostsStore;
